import React, { useState } from "react";
import Styles from "./UserAvatar.module.css";
import { GrLogout } from "@react-icons/all-files/gr/GrLogout";
import userManager from "../../../utils/userManager";
import { IconContext } from "react-icons";
export type LogoutProps = {
  title: string;
  message: string;
  actionType: string;
  actionToDisplay: string;
};
const UserAvatar: React.FC = () => {
  const [showPopup, setShowPopup] = useState(false);
  const handleAvatarClick = () => {
    setShowPopup(!showPopup);
  };

  const initial = localStorage.getItem("email")?.charAt(0).toUpperCase();

  window.addEventListener("storage", (event) => {
    if (event.key === "clearLocalStorage") {
      localStorage.clear();
    }
  });

  const handleSSOLogout = () => {
    try {
      setTimeout(async () => {
        clearAuthStorage();
        userManager.clearStaleState();
        userManager.removeUser();
        userManager
          .signoutRedirect()
          .then((success) => {
            console.log("Logged out");
          })
          .catch((ex) => {
            console.error(ex);
          });
      }, 1500);
    } catch (ex) {
      console.error(ex);
    }
  };

  const clearAuthStorage = () => {
    window.localStorage.clear();
  };

  return (
    <>
      <div className={Styles.avatarContainer}>
        <div className={Styles.avatar} onClick={handleAvatarClick}>
          {initial}
        </div>
        {showPopup && (
          <div className={Styles.popup}>
            <IconContext.Provider value={{ color: "#f06c00", size: "2em" }}>
              <GrLogout
                size={22}
                style={{
                  marginTop: "3px",
                  color: "#f06c00",
                  marginLeft: "4px",
                  marginRight: "4px"
                }}
                className={Styles.icon}
                color="#f06c00"
              />
            </IconContext.Provider>
            <button onClick={handleSSOLogout} className={Styles.logoutBtn}>
              Logout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default UserAvatar;
